import React, { useEffect } from "react";
import { Link, useLocation } from "react-router-dom";
import GlobalLogo from "../SvgIcons/GlobalLogo";
import IconAbout from "../SvgIcons/IconAbout";
import IconContact from "../SvgIcons/IconContact";
import IconDownloads from "../SvgIcons/IconDownloads";
import IconEvents from "../SvgIcons/IconEvents";
import IconHome from "../SvgIcons/IconHome";
import IconPricing from "../SvgIcons/IconPricing";
import IconProducts from "../SvgIcons/IconProducts";
import IconServices from "../SvgIcons/IconServices";
import IconTallyprime from "../SvgIcons/IconTallyprime";
import IconTallyPServerSmall from "../SvgIcons/IconTallyPServerSmall";
import IconTallySupport from "../SvgIcons/IconTallySupport";

export default function Navigation() {
  const location = useLocation();
  useEffect(() => {
    document.body.classList.remove("hidemobile");
  }, [location]);


  useEffect(() => {
    const items = document.querySelectorAll(".menubox-li[data-has-dropdown]");
  
    items.forEach((item) => {
      const dropdown = item.querySelector(".dropdownhover");
  
      item.addEventListener("mouseenter", () => {
        dropdown.classList.add("visible");
      });
  
      item.addEventListener("mouseleave", () => {
        dropdown.classList.remove("visible");
      });
    });
  
    return () => {
      // Cleanup event listeners on unmount
      items.forEach((item) => {
        item.removeEventListener("mouseenter", () => {});
        item.removeEventListener("mouseleave", () => {});
      });
    };
  }, []);

  return (
    <div
      className="navigation"
    >
      <ul className="d-flex">
        <li>
          <Link to="/" className="menubox homemenu">
            <IconHome />
            <span>Home</span>
          </Link>
        </li>

        <li className="menubox-li" data-has-dropdown>

          <Link className="menubox productsmenu">
            <IconProducts />
            <span>Products</span>
          </Link>
          <div
            className="dropdownhover"
          >
            <ul className="submenu">
              <li>
                <Link to="/tally-prime">
                  <div className="icontop">
                    <img
                      src="../images/tally-logo-center.png"
                      alt="Tally Center"
                    />
                  </div>
                  Tally Products
                </Link>
              </li>
              <li>
                <Link to="/our-products">
                  <div className="icontop">
                    <img src="../images/gl.png" alt="Global Software" />
                  </div>
                  Our Solutions & Products
                </Link>
              </li>
            </ul>
          </div>
        </li>

        <li>
          <Link to="/tally-support" className="menubox servicesmenu">
            <IconServices />
            <span>Services</span>
          </Link>
        </li>

        <li>
          <Link to="/price-tanzania" className="menubox pricingmenu">
            <IconPricing />
            <span>Pricing</span>
          </Link>
        </li>

        <div className="logo">
          <Link
            to="/"
            onClick={() => {
              window.scrollTo({ top: 0 });
            }}
          >
            <GlobalLogo />
          </Link>
        </div>

        <li>
          <Link to="/events" className="menubox eventsmenu">
            <IconEvents />
            <span>Events</span>
          </Link>
        </li>

        <li className="menubox-li" data-has-dropdown>
          <Link className="menubox downloadsmenu">
            <IconDownloads />
            <span>Downloads</span>
          </Link>
          <div
            className="dropdownhover"
          >
            <ul className="submenu">
              <li>
                <a href="../images/satup/tallyprime_setup6-0.exe" download>
                  <div className="icontop">
                    <IconTallyprime />
                  </div>
                  Tallyprime
                </a>
              </li>
              <li>
                <a
                  href="../images/satup/TallyPrimeServer_setup6-0.exe"
                  download
                >
                  <div className="icontop">
                    <IconTallyPServerSmall />
                  </div>
                  TallyPrime Server
                </a>
              </li>

              <li>
                <a href="../images/satup/AnyDesk.exe" download>
                  <div className="icontop">
                    <img src="../images/anydesk.png" alt="anydesk" />
                  </div>
                  AnyDesk
                </a>
              </li>
              <li>
                <a href="../images/satup/UltraViewer_Desktop.exe" download>
                  <div className="icontop">
                    <img
                      src="../images/UltraViewer.png"
                      alt="UltraViewer"
                      width={23}
                      height={23}
                    />
                  </div>
                  Ultra Viewer
                </a>
              </li>
              <li>
                <Link to="https://gatewayinfosoft.com/crf/" target="_blank">
                  <div className="icontop">
                    <IconTallySupport />
                  </div>
                  Global Tally Care App
                </Link>
              </li>
            </ul>
          </div>
        </li>
        <li>
          <Link to="/contact" className="menubox contactmenu">
            <IconContact />
            <span>Contact</span>
          </Link>
        </li>
        <li>
          <Link to="/about" className="menubox aboutmenu">
            <IconAbout />
            <span>About</span>
          </Link>
        </li>
      </ul>
    </div>
  );
}
